<style>
    .k-grid .k-header {
        white-space: normal;}
    .errMsg { color: #FF0000; }
</style>
<div class="sendToInvoice" style="height: calc(100vh - 15px);" *ngIf="showSendArPanel">
    <div class="side-panel-content" [ngStyle]="{'width': showIntacctResponseSidePanel ? '1430px' : '800px'}"
        style="overflow-y: auto; overflow-x: hidden; display: flex; padding: 0 0px 0 0;">
        <div *ngIf="showIntacctResponseSidePanel" style="width: 600px; padding: 30px 0 0 0;">
            <div class="row" style="color: black; font-size: 30px;">
                <div class="col-md-12 align-center">
                    <label class="side-panel-header"><i class="fa fa-lg" style="padding-right: 1em;"></i>Intacct Response</label>
                </div>
            </div>
            <div style="overflow-y: scroll; overflow-x: hidden; height: calc(100vh - 80px);">
                <kendo-grid 
                    [data]="intacctResponse" 
                    [loading]="sendInvoicesInprogress"
                    [ngStyle]="{height: 'calc(100vh - 80px)'}"
                    style="border: none;">
                    <kendo-grid-column field="message" title="Messages">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="whole-cell" [ngClass]="{'errMsg': dataItem.isError}">
                                {{ dataItem.message }}
                            </span>
                            </ng-template>
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
        <div class="align-center side-panel-preview-separator"
            style="width: 30px; height: 100vh;" *ngIf="showIntacctResponseSidePanel"
            (click)="showIntacctResponseSidePanel = false;">
            <i class="fa fa-angle-right fa-2x" style="margin-top: calc(50vh - 30px);"></i>
        </div>
        <!-- <div class="align-center side-panel-preview-separator"
            style="width: 30px; height: 100vh;" *ngIf="!showIntacctResponseSidePanel"
            (click)="showIntacctResponseSidePanel = true;">
            <i class="fa fa-angle-left fa-2x" style="margin-top: calc(50vh - 30px);"></i>
        </div> -->
        <div style="width: 800px; padding: 30px 0 0 0;">
            <div class="row" style="color: black; font-size: 30px; height: 10vh;">
                <div class="col-md-10 align-center">
                    <label class="side-panel-header" >
                        <i class="fa fa-lg fa-share rail360-success" style="padding-right: 1em;"></i> Send to Intacct
                    </label>
                </div>
                <div *ngIf="!sendInvoicesInprogress && !arPreviewLoading" class="col-md-2 align-center">
                    <a class="side-panel-close" (click)="closeComponent()">X</a>
                </div>
            </div>
            <div class="row" style="height: 13vh;">
                <div class="col-md-3"></div>
                <div class="col-md-6">
                    <button
                        name="sendArToIntaact"
                        id="SendArToIntaact"
                        class="btn rail360-primary-item btn-rectangle-lg"
                        (click)="sendArToIntacct()"
                        [disabled]="sendInvoicesInprogress || !canSendAr">Send
                    </button>
                </div>
                <div class="col-md-3"></div>
            </div>
            <div class="row" style="height: 7vh; text-align: center;">
                <div class="col-md-12" style="margin-top: 10px; margin-bottom: 3px;">
                    <kendo-progressbar
                        [value]="totalSentToIntacct"
                        [max]="selectedArInvoices?.length"
                        [label]="label"
                        [progressCssStyle]="{background: 'var(--success)'}"
                        [animation]="true">
                    </kendo-progressbar>
                </div>
                <label class="data">{{arProgressLabel}}</label>
            </div>
            <div class="row" style="height: 65vh;">
                <div class="col-md-12" *ngIf="needPreview">
                    <h2 style="padding-left: 1em;">Preview</h2>
                    <kendo-grid
                        [data]="selectedArInvoices"
                        [loading]="arPreviewLoading || sendInvoicesInprogress"
                        [ngStyle]="{'height': getPreviewGridHeight()}">
                        <kendo-grid-column title="Invoice #" field="invoiceNumber" width="120px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div [ngClass]="{'text-danger': dataItem.hasError}">{{dataItem.invoiceNumber}}</div>
                            </ng-template>
                        </kendo-grid-column>
                        <!-- grid columns for isCustomerRebill ARs -->
                        <kendo-grid-column *ngIf="isCustomerRebill" title="Lease #" field="leaseNumber" width="100px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div [ngClass]="{'text-danger': dataItem.hasError}">{{dataItem.leaseNumber}}</div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isCustomerRebill" title="GL Processing Date" field="glPostingDate" width="150px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <kendo-datepicker
                                    [(value)]="dataItem.glPostingDate"
                                    placeholder=" " 
                                    formatPlaceholder="short" 
                                    style="width: 130px;"
                                    (valueChange)="updateInvoiceProcessDate(dataItem.glPostingDate, dataItem.invoiceNumber)">
                                </kendo-datepicker>
                            </ng-template>
                            <ng-template kendoGridFooterTemplate>
                                Total
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isCustomerRebill" title="AR Credit" field="totalCredit" format="{0:c}">
                            <ng-template kendoGridFooterTemplate>
                                {{arPreviewArTotal?.totalCredit?.sum | currency}}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isCustomerRebill" title="AR Total" field="total" format="{0:c}">
                            <ng-template kendoGridFooterTemplate>
                                {{arPreviewArTotal?.total?.sum | currency}}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isCustomerRebill" title="Intacct AP Total" field="intacctApTotal" format="{0:c}">
                            <ng-template kendoGridFooterTemplate>
                                {{arPreviewArTotal?.intacctApTotal?.sum | currency}}
                            </ng-template>
                        </kendo-grid-column>
                    </kendo-grid>
                </div>

                <div class="col-md-12" *ngIf="!needPreview">
                    <kendo-grid
                        [data]="selectedArInvoices"
                        [loading]="arPreviewLoading || sendInvoicesInprogress"
                        [ngStyle]="{'height': getPreviewGridHeight()}">
                        <!-- BaseRental Owner Ar Columns -->
                        <kendo-grid-column *ngIf="isBaseRentalOwnerAr" title="Invoice #" field="invoiceNumber" width="120px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div [ngClass]="{'text-danger': dataItem.hasError}">{{dataItem.invoiceNumber}}</div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isBaseRentalOwnerAr" title="Ownership Code" field="ownershipCode" width="120px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div [ngClass]="{'text-danger': dataItem.hasError}">{{dataItem.ownershipCode}}</div>
                            </ng-template>
                            <ng-template kendoGridFooterTemplate>
                                Total
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isBaseRentalOwnerAr" title="Lease #" field="leaseNumber" width="120px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div [ngClass]="{'text-danger': dataItem.hasError}">{{dataItem.leaseNumber}}</div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isBaseRentalOwnerAr" title="Ownership" field="ownerName" width="150px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div [ngClass]="{'text-danger': dataItem.hasError}">{{dataItem.ownerName}}</div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isBaseRentalOwnerAr" title="$ Credit Total" field="creditTotal" format="{0:c}">
                            <ng-template kendoGridFooterTemplate>
                                {{baseRentalTotals?.creditTotal?.sum | currency}}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isBaseRentalOwnerAr" title="$ Debit Total" field="debitTotal" format="{0:c}">
                            <ng-template kendoGridFooterTemplate>
                                {{baseRentalTotals?.debitTotal?.sum | currency}}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isBaseRentalOwnerAr" title="$ Grand Total" field="grandTotal" format="{0:c}">
                            <ng-template kendoGridFooterTemplate>
                                {{baseRentalTotals?.grandTotal?.sum | currency}}
                            </ng-template>
                        </kendo-grid-column>
                        <!-- BaseRental Customer Ar Columns -->
                        <kendo-grid-column *ngIf="isBaseRentalAr && !isBaseRentalOwnerAr" title="Invoice #" field="invoiceNumber" width="120px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div [ngClass]="{'text-danger': dataItem.hasError}">{{dataItem.invoiceNumber}}</div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isBaseRentalAr && !isBaseRentalOwnerAr" title="Lease #" field="leaseNumber" width="120px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div [ngClass]="{'text-danger': dataItem.hasError}">{{dataItem.leaseNumber}}</div>
                            </ng-template>
                            <ng-template kendoGridFooterTemplate>
                                Total
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isBaseRentalAr && !isBaseRentalOwnerAr" title="$ Base Total" field="baseTotal" format="{0:c}">
                            <ng-template kendoGridFooterTemplate>
                                {{baseRentalTotals?.baseTotal?.sum | currency}}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isBaseRentalAr && !isBaseRentalOwnerAr" title="$ Adjustment Total" field="adjustmentTotal" format="{0:c}">
                            <ng-template kendoGridFooterTemplate>
                                {{baseRentalTotals?.adjustmentTotal?.sum | currency}}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isBaseRentalAr && !isBaseRentalOwnerAr" title="$ Grand Total" field="total" format="{0:c}">
                            <ng-template kendoGridFooterTemplate>
                                {{baseRentalTotals?.total?.sum | currency}}
                            </ng-template>
                        </kendo-grid-column>
                        <!-- CarHireCustomer Ar Columns-->
                        <kendo-grid-column *ngIf="isCarHireCustomerAr" title="Invoice #" field="invoiceNumber" width="120px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div [ngClass]="{'text-danger': dataItem.hasError}">{{dataItem.invoiceNumber}}</div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isCarHireCustomerAr" title="Lease #" field="leaseNumber" width="100px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div [ngClass]="{'text-danger': dataItem.hasError}">{{dataItem.leaseNumber}}</div>
                            </ng-template>
                            <ng-template kendoGridFooterTemplate>
                                Total
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isCarHireCustomerAr" title="$ Mileage Total" field="mileageTotal" format="{0:c}">
                            <ng-template kendoGridFooterTemplate>
                                {{carhireTotals?.mileageTotal?.sum | currency}}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isCarHireCustomerAr" title="$ Tax Total" field="taxTotal" format="{0:c}">
                            <ng-template kendoGridFooterTemplate>
                                {{carhireTotals?.taxTotal?.sum | currency}}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isCarHireCustomerAr" title="$ Grand Total" field="grandTotal" format="{0:c}">
                            <ng-template kendoGridFooterTemplate>
                                {{carhireTotals?.grandTotal?.sum | currency}}
                            </ng-template>
                        </kendo-grid-column>
                        <!-- NoWorkCustomer Ar Columns-->
                        <kendo-grid-column *ngIf="isNoWorkCustomerAr" title="Invoice #" field="invoiceNumber" width="200px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div [ngClass]="{'text-danger': dataItem.hasError}">{{dataItem.invoiceNumber}}</div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isNoWorkCustomerAr" title="Lease #" field="leaseNumber" width="200px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div [ngClass]="{'text-danger': dataItem.hasError}">{{dataItem.leaseNumber}}</div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isNoWorkCustomerAr" title="GL Processing Date" field="invoiceProcessedDate" width="250px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <kendo-datepicker
                                    [(value)]="dataItem.glPostingDate"
                                    placeholder=" " 
                                    formatPlaceholder="short" 
                                    style="width: 130px;"
                                    (valueChange)="updateInvoiceProcessDate(dataItem.glPostingDate, dataItem.invoiceNumber)">
                                </kendo-datepicker>
                            </ng-template>
                            <ng-template kendoGridFooterTemplate>
                                Total
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isNoWorkCustomerAr" title="$ Total" field="totalCharge" format="{0:c}">
                            <ng-template kendoGridFooterTemplate>
                                {{noWorkTotals?.totalCharge?.sum | currency}}
                            </ng-template>
                        </kendo-grid-column>
                        <!-- Scrap Ar Columns-->
                        <kendo-grid-column *ngIf="isScrapAr" title="Invoice #" field="invoiceNumber" width="200px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div [ngClass]="{'text-danger': dataItem.hasError}">{{dataItem.invoiceNumber}}</div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isScrapAr" title="GL Processing Date" field="invoiceProcessedDate" width="350px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <kendo-datepicker
                                    [(value)]="dataItem.glPostingDate"
                                    placeholder=" " 
                                    formatPlaceholder="short" 
                                    style="width: 130px;"
                                    (valueChange)="updateInvoiceProcessDate(dataItem.glPostingDate, dataItem.invoiceNumber)">
                                </kendo-datepicker>
                            </ng-template>
                            <ng-template kendoGridFooterTemplate>
                                Total
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isScrapAr" title="$ Total" field="totalCharge" format="{0:c}">
                            <ng-template kendoGridFooterTemplate>
                                {{scrapTotals?.totalCharge?.sum | currency}}
                            </ng-template>
                        </kendo-grid-column>

                        <!-- grid columns for isArExcessMileage AR -->
                        <kendo-grid-column *ngIf="isExcessMileageAr" title="Invoice #" field="invoiceNumber" width="110px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div [ngClass]="{'text-danger': dataItem.hasError}">{{dataItem.invoiceNumber}}</div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isExcessMileageAr" title="Customer" field="customerName">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div [ngClass]="{'text-danger': dataItem.hasError}">{{dataItem.customerName}}</div>
                            </ng-template>
                            <ng-template kendoGridFooterTemplate>
                                Total
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isExcessMileageAr" title="Total Allowances" field="invoiceLeaseAllowances" format="{0:n}">
                            <ng-template kendoGridFooterTemplate>
                                {{arExceedMileageTotals?.invoiceLeaseAllowances?.sum | number}}
                            </ng-template>
                        </kendo-grid-column> 
                        <kendo-grid-column *ngIf="isExcessMileageAr" title="Total Miles" field="invoiceTotalMiles" format="{0:n}">
                            <ng-template kendoGridFooterTemplate>
                                {{arExceedMileageTotals?.invoiceTotalMiles?.sum | number}}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isExcessMileageAr" title="Total Exceeded" field="invoiceExceededMiles" format="{0:n}">
                            <ng-template kendoGridFooterTemplate>
                                {{arExceedMileageTotals?.invoiceExceededMiles?.sum | number}}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isExcessMileageAr" title="Total Penalty" field="invoicePenaltyAmount" format="{0:c}">
                            <ng-template kendoGridFooterTemplate>
                                {{arExceedMileageTotals?.invoicePenaltyAmount?.sum | currency}}
                            </ng-template>
                        </kendo-grid-column>

                        <!-- grid columns for isTankcarEqualizationAr AR -->
                        <kendo-grid-column *ngIf="isTankcarEqualizationAr" title="Invoice #" field="invoiceNumber" width="110px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div [ngClass]="{'text-danger': dataItem.hasError}">{{dataItem.invoiceNumber}}</div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isTankcarEqualizationAr" title="Customer" field="customerName">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div [ngClass]="{'text-danger': dataItem.hasError}">{{dataItem.customerName}}</div>
                            </ng-template>
                            <ng-template kendoGridFooterTemplate>
                                Total
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isTankcarEqualizationAr" title="Leases" field="leases" >
                        </kendo-grid-column> 
                        <kendo-grid-column *ngIf="isTankcarEqualizationAr" title="Equalization Penalty" field="invoiceTeAmount" format="{0:c}">
                            <ng-template kendoGridFooterTemplate>
                                {{arTankcarEqualizationTotals?.excessAmount?.sum | currency}}
                            </ng-template>
                        </kendo-grid-column>

                        <!-- Stip Loss/FMV Ar Columns-->
                        <kendo-grid-column *ngIf="isStipLossAr || isFmvAr" title="Invoice #" field="invoiceNumber" width="200px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div [ngClass]="{'text-danger': dataItem.hasError}">{{dataItem.invoiceNumber}}</div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isStipLossAr || isFmvAr" title="GL Processing Date" field="invoiceProcessedDate" width="350px">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <kendo-datepicker
                                    [(value)]="dataItem.glPostingDate"
                                    placeholder=" " 
                                    formatPlaceholder="short" 
                                    style="width: 130px;"
                                    (valueChange)="updateInvoiceProcessDate(dataItem.glPostingDate, dataItem.invoiceNumber)">
                                </kendo-datepicker>
                            </ng-template>
                            <ng-template kendoGridFooterTemplate>
                                Total
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="isStipLossAr || isFmvAr" title="$ Total" field="totalCharge" format="{0:c}">
                            <ng-template kendoGridFooterTemplate>
                                {{stipLossFmvTotals?.totalCharge?.sum | currency}}
                            </ng-template>
                        </kendo-grid-column>
                    </kendo-grid>
                </div>
            </div>
            <div *ngIf="arPreviewLoading || sendInvoicesInprogress" style="text-align: center;">
                <span class="k-icon k-i-loading" style="font-size: 42px;" [ngStyle]="{'margin-top': getMarginAboveGrid()}"></span>
            </div>
        </div>
    </div>
</div>
